export default {"src":"/_next/static/media/mayonnaise.9016f4fb.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};